import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import LockIcon from '../../../../commonComponents/icons/LockIcon';

const LevelCard = props => {
  const { t, index, levelData } = props;

  const {
    level,
    skillLevel,
    personalVA,
    weakLegVA,
    vaOnEachLeg,
    recruitGoals,
    daysLeft,
  } = levelData;

  const isLevelComplete = cardIndex => {
    if (cardIndex === 0) {
      return level > 0;
    }
    return false;
  };

  const isStageComplete = stageObject => stageObject?.limitAchieved;

  const levelProgress = () => ((7 - daysLeft || 0) / 7) * 100;

  return (
    <div className={`level-card card-${index + 1}`}>
      {isLevelComplete(index) && (
        <div className="cardBookmark">
          <span className="cardBookmarkText">
            {t('report.arcova.levelCompleted')}
            <img
              src="/images/reports/party-hat.svg"
              alt="yay"
              className="partyHat"
            />
          </span>
        </div>
      )}
      <div className="cardHeader">
        {index === 2 && (
          <div className="cardLockContainer">
            <LockIcon width={76} height={96} />
          </div>
        )}
        <span className="levelLabel">
          {t('report.arcova.level')} {level}
        </span>
        <img
          src={skillLevel.icon}
          alt={skillLevel.name}
          className="level-card-image"
        />
        {isLevelComplete(index) && (
          <div className="completedLevelCheck">
            <CheckIcon />
          </div>
        )}
        <span className="levelLabelName">{skillLevel.name}</span>
        {index === 1 && (
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${levelProgress()}%`,
              }}
            >
              {daysLeft || '-'}{' '}
              {daysLeft === 1 ? t('dayLeft') : t('report.arcova.daysLeft')}
            </div>
          </div>
        )}
      </div>
      <div className="cardTableBody">
        <table className="table" style={{ width: '100%' }}>
          <tbody>
            <tr className="content" key="row-1">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(personalVA) && <CheckIcon color="#3FBC5F" />}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{personalVA?.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-2">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(weakLegVA) && <CheckIcon color="#3FBC5F" />}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{weakLegVA?.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-3">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(vaOnEachLeg) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{vaOnEachLeg?.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-4">
              <td className="contentCell">
                <div className="goal-container">
                  {recruitGoals.length > 0 ? (
                    recruitGoals.map(goal => (
                      <div className="goal" key={goal.recruitGoalLevel}>
                        <div className="completedStageCheck">
                          {goal.recruitGoalAchieved && (
                            <CheckIcon color="#3FBC5F" />
                          )}
                        </div>
                        <span className="contentCellText">
                          &gt;=&nbsp;{goal.recruitGoalAmount} (
                          {t('report.liveoben.objectives.atLeastLevel')}
                          {goal.recruitGoalLevel})
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="goal">
                      <div className="completedStageCheck">
                        <CheckIcon color="#3FBC5F" />
                      </div>
                      <span className="contentCellText">-</span>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

LevelCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  levelData: PropTypes.shape({
    level: PropTypes.number.isRequired,
    daysLeft: PropTypes.number.isRequired,
    skillLevel: PropTypes.shape({
      icon: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    personalVA: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    weakLegVA: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    vaOnEachLeg: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    recruitGoals: PropTypes.arrayOf({
      recruitGoalLevel: PropTypes.number,
      recruitGoalAmount: PropTypes.number,
      recruitGoalAchieved: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default translate(LevelCard);
